// extracted by mini-css-extract-plugin
export default {"name":"ProviderItem_name__WapQQ","value":"ProviderItem_value__nOGrk","row":"ProviderItem_row__Znk23"};